import { SpaceBetween, Box, ExpandableSection, ColumnLayout } from '@amzn/awsui-components-console';
import React, { useEffect, useState } from 'react';
import { getValueWithLabel } from '../../lab-management/group/utils';

/**
 * get time to live from seconds to a date
 * @return {String} date string
 */
export function getDate(dateInMillis) {
    const date = new Date(parseInt(dateInMillis) * 1000);
    return date.toUTCString();
}

/**
 * for each subsection of custom config, get a component
 * @param {*} name
 * @param {*} config
 * @param {*} items
 * @returns
 */
const getTags = (tags) => {
    if (!tags || tags.length === 0) return [];
    return tags.map((tag) => {
        let tagKey = '';
        let tagValue = '';
        Object.entries(tag).forEach(([key, value]) => {
            tagKey = key;
            tagValue = value;
        });
        return getValueWithLabel(tagKey, tagValue);
    });
};

export const getCustomTags = (tags) => {
    const customTagsComponents = getTags(tags);

    return (
        <ExpandableSection headerText="See details">
            <ColumnLayout columns={4} variant="text-grid">
                <SpaceBetween size="s">{customTagsComponents}</SpaceBetween>
            </ColumnLayout>
        </ExpandableSection>
    );
};
